<script setup lang="ts">
import { useConfigurator } from '@/composables/configurator/useConfigurator'

const { inactivity, callDurationLimits } = useConfigurator()
</script>

<template>
  <CallLimits
    v-model:inactivity="inactivity"
    v-model:call-duration-limits="callDurationLimits"
    data-testid="call-limits-tab-content"
  />
</template>
